import styled from 'styled-components';

export const BannerWrapper = styled.div`
  width: 100%;
  margin-bottom: var(--spacing-medium);
`;

// Plain anchor (not the app Link) — banner targets may be external.
export const BannerLink = styled.a`
  display: block;

  &:focus-visible {
    box-shadow: var(--shadow-focus);
    border-radius: var(--radius-large);
    outline: 0;
  }
`;

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  /* Reserve the box before the image loads to avoid layout shift (CLS).
     Tune the ratio to the merchandised banner's dimensions; object-fit: cover
     fills the reserved box (switch to contain to avoid any cropping). */
  aspect-ratio: 4 / 1;
  object-fit: cover;
  border-radius: var(--radius-large);
`;
